import React from 'react';
import Button from '../../../../../muiComponents/Button';
import Card from '../../../../../muiComponents/Card';
import { LinearProgress } from '@mui/material';
import useTranslate from '../../../../../customHooks/useTranslate';
import Tooltip from '../../../../../muiComponents/Tooltip';
import { usePropertyFetching } from '../../../../contextsProperty/ContextProperties';
import LoadingPlaceholder from '../../../../../muiComponents/LoadingPlaceholder';

interface StepCardProps {
    title: string;
    description: string;
    progress?: number;
    buttonText?: string;
    onButtonClick: () => void;
    isButtonDisabled: boolean;
}

const StepCard = ({
    title,
    description,
    progress,
    buttonText,
    onButtonClick,
    isButtonDisabled,
}: StepCardProps) => {
    const { isFetching } = usePropertyFetching();
    const translate = useTranslate();

    const titleText = translate(title);
    const descriptionText = translate(description);

    const defaultButtonText =
        progress === 0
            ? translate('start')
            : progress === 100
            ? translate('edit')
            : translate('continue');

    const translatedButtonText = buttonText
        ? translate(buttonText)
        : defaultButtonText;
    const completedText = translate('completed_progress');

    return (
        <Card className='step-card'>
            <div className='flex-column gap-8'>
                {isFetching ? (
                    <LoadingPlaceholder variant='text' />
                ) : (
                    <h2 className='step-card__title'>{titleText}</h2>
                )}
                {isFetching ? (
                    <LoadingPlaceholder variant='text' />
                ) : (
                    <p>{descriptionText}</p>
                )}
            </div>
            <div
                className={`flex flex-${
                    progress !== undefined ? 'between' : 'end'
                } flex-align-end`}
            >
                {progress !== undefined ? (
                    <Tooltip title={`${completedText} ${progress}%`}>
                        {isFetching ? (
                            <LoadingPlaceholder
                                variant='text'
                                className='step-progress'
                            />
                        ) : (
                            <LinearProgress
                                variant='determinate'
                                value={progress}
                                className='step-progress'
                            />
                        )}
                    </Tooltip>
                ) : (
                    ''
                )}
                <Button
                    variant='contained'
                    onClick={onButtonClick}
                    disabled={isButtonDisabled || isFetching}
                >
                    {translatedButtonText}
                </Button>
            </div>
        </Card>
    );
};

export default StepCard;
